import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { useDispatch } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../../components/Footer";
import userStore from "../../../zustand/userStore";
import { logout } from "../../../../src/auth/authSlice";

const DocumentsDashboard2 = () => {
  const { pathname } = useLocation();
  const navItems = [
    {
      path: "/dashboard",
      label: "Home",
      icon: "fa-home",
    },
    {
      path: "/studentDocuments",
      label: "List of Documents",
      icon: "fa-file-text-o",
    },
    {
      path: "/DocFormDraft/1",
      label: "Documents in Process",
      icon: "fa-file-text-o",
    },
    {
      path: "/myDocumentForms",
      label: "My Documents",
      icon: "fa-file-text-o",
    },
    {
      path: "/myPrefills",
      label: "Prefills",
      icon: "fa-keyboard",
    },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);

  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };
  return (
    <nav
      className="navbar navbar-expand-lg p-0"
      style={{
        background: "linear-gradient(to right, #7B2FF7 50%, #F40076 100%)",
        fontSize: "0.85rem",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      <div
        className="container-fluid ps-3 mx-auto"
        style={{ maxWidth: "100%" }}
      >
        <button
          className="navbar-toggler mx-2"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav d-flex align-items-start">
            {navItems.map((item) => (
              <li
                key={item.path}
                className={`nav-item mx-2 ${
                  pathname === item.path ? "active" : ""
                }`}
              >
                <Link
                  className="nav-link text-white hover-effect"
                  to={item.path}
                >
                  <i
                    className={`fa ${item.icon} me-1`}
                    style={{ pointerEvents: "none" }}
                  ></i>
                  {item.label}
                  <div className="active-indicator"></div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <style jsx>{`
        .nav-item.active .nav-link {
          font-weight: 600;
          background-color: #f3e5f5;
          color: #7b2ff7 !important;
          border-radius: 4px;
        }

        .active-indicator {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 3px;
          background: #bbdefb;
          transition: width 0.3s ease;
        }

        .nav-item.active .active-indicator {
          width: 80%;
        }

        .nav-link {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 0.5rem 1rem;
          position: relative;
          transition: all 0.3s ease;
          border-radius: 4px;
          font-size: 14px;
        }

        .hover-effect:hover {
          background-color: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
        }

        .nav-item.active .hover-effect:hover {
          background-color: rgba(255, 255, 255, 0.25);
        }

        .navbar-nav {
          gap: 0.5rem;
        }
      `}</style>
    </nav>
  );
};

const StudentsDocumentLayout = () => {
  const userData = userStore((state) => state.user);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getMasterDataByUserId(userData.id));
  // }, [dispatch, userData?.id]);

  return (
    <div className="container-fluid vh-100 d-flex flex-column p-0">
      {/* <Header /> */}
      {/* <Header2 /> */}

      <div className="row flex-grow-1 m-0 overflow-hidden">
        <div className="col-12 p-0 d-flex flex-column h-100">
          {/* Sidebar */}
          <DocumentsDashboard2 />

          <div
            className="flex-grow-1 overflow-hidden d-flex"
            style={{
              position: "relative",
              background:
                "linear-gradient(to bottom, #ffffff 40%, #B9D9F0 100%)",
            }}
          >
            <div
              style={{
                content: "''",
                backgroundImage: `url('/images/schoold-home-banner.png')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "50%",
                opacity: 0.15,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0,
              }}
            />

            <div
              className="overflow-auto w-100 py-3 px-5"
              style={{
                zIndex: 1,
                position: "relative",
              }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StudentsDocumentLayout;
